import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './globalStyles';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import PageNotFound from './404';
import Mainpage from './homepage/Mainpage';
import { BlogListDetails } from './local-api/blogsListing'

const App = lazy(() => import('./App'));
const Thankyou = lazy(() => import('./Thankyou'));
const Commingsoon = lazy(() => import('./Commingsoon'));
// import Index from './componentsfamilyhub/Familyhub';
const Familyhub = lazy(() => import('./componentsfamilyhub/Familyhub'));
const ThankyouLeisureValley = lazy(() => import('./Thankyou-aspire-leisure-valley'));
const ThankyouFamilyHub = lazy(() => import('./Thankyoufamilyhub'));
const AspireSiliconCity = lazy(() => import('./aspire-silicon-city/AspireSiliconCity'));
const AuAspireSiliconCity = lazy(() => import('./au-aspire-silicon-city/AspireSiliconCity'));
const CosmosCorner = lazy(() => import('./cosmos-corner/CosmosCorner'));
const BbfScholarProgram = lazy(() => import('./bbf-scholar-program/BbfScholarProgram'));
const BbfApplicationForm = lazy(() => import('./bbf-scholar-program/BbfApplicationForm'));
const Aboutus = lazy(() => import('./homepage/Aboutus'));
const Newspage = lazy(() => import('./homepage/Newspage'));
const Contactus = lazy(() => import('./homepage/Contactus'));
const Commingsoonpage = lazy(() => import('./homepage/Commingsoonpage'));
const Privacypolicy = lazy(() => import('./homepage/Privacypolicy'));
const Terms = lazy(() => import('./homepage/Terms'));
const Disclaimer = lazy(() => import('./homepage/Disclaimer'));
const Advisorycomingsoon = lazy(() => import('./homepage/Advisorycomingsoon'));
const Servicecomingsoon = lazy(() => import('./homepage/Servicecomingsoon'));
const Jointcomingsoon = lazy(() => import('./homepage/Jointcomingsoon'));
const Career = lazy(() => import('./homepage/Career'));
const Service = lazy(() => import('./homepage/Service'));
const Advisory = lazy(() => import('./homepage/Advisory'));
const Jointventures = lazy(() => import('./homepage/Joint-ventures'));
const Thankyoumain = lazy(() => import('./Thankyou-main'));
// import Residences from './homepage/Residences';
// import Commercial from './homepage/Commercial';
const Blogdetail = lazy(() => import('./homepage/Blog-detail'));
const Blogdetail2 = lazy(() => import('./homepage/Blog-detail2'));
const Blogdetail3 = lazy(() => import('./homepage/Blog-detail3'));
const Blogdetail5 = lazy(() => import('./homepage/Blog-detail5'));
const Blogdetail6 = lazy(() => import('./homepage/Blog-detail6'));
const Blogdetail7 = lazy(() => import('./homepage/Blog-detail7'));
const Blogdetail8 = lazy(() => import('./homepage/Blog-detail8'));
const Blogdetail9 = lazy(() => import('./homepage/Blog-detail9'));
const Blogdetail10 = lazy(() => import('./homepage/Blog-detail10'));
const Blogdetail11 = lazy(() => import('./homepage/Blog-detail11'));
const Blogdetail12 = lazy(() => import('./homepage/Blog-detail12'));
const Blogdetail13 = lazy(() => import('./homepage/Blog-detail13'));
const Blogdetail14 = lazy(() => import('./homepage/Blog-detail14'));
const Blogdetail15 = lazy(() => import('./homepage/Blog-detail15'));
const Blogdetail16 = lazy(() => import('./homepage/Blog-detail16'));
const Blogdetail17 = lazy(() => import('./homepage/Blog-detail17'));
const Blogdetail18 = lazy(() => import('./homepage/Blog-detail18'));
const Blogdetail19 = lazy(() => import('./homepage/Blog-detail19'));
const Blogdetail20 = lazy(() => import('./homepage/Blog-detail20'));
const Blogdetail21 = lazy(() => import('./homepage/Blog-detail21'));
const Blogdetail22 = lazy(() => import('./homepage/Blog-detail22'));
const Blogdetail23 = lazy(() => import('./homepage/Blog-detail23'));
const Blogdetail24 = lazy(() => import('./homepage/Blog-detail24'));
const Blogdetail25 = lazy(() => import('./homepage/Blog-detail25'));
const Blogdetail26 = lazy(() => import('./homepage/Blog-detail26'));
const Blogdetail27 = lazy(() => import('./homepage/Blog-detail27'));
const Blogdetail28 = lazy(() => import('./homepage/Blog-detail28'));
const Blogdetail29 = lazy(() => import('./homepage/Blog-detail29'));
const Blogdetail30 = lazy(() => import('./homepage/Blog-detail30'));
const Blogdetail31 = lazy(() => import('./homepage/Blog-detail31'));
const Blogdetail32 = lazy(() => import('./homepage/Blog-detail32'));
const Blogdetail33 = lazy(() => import('./homepage/Blog-detail33'));
const Blogdetail34 = lazy(() => import('./homepage/Blog-detail34'));
const Blogdetail35 = lazy(() => import('./homepage/Blog-detail35'));
const Blogdetail36 = lazy(() => import('./homepage/Blog-detail36'));
const Blogdetail37 = lazy(() => import('./homepage/Blog-detail37'));
const BlogsDetail = lazy(() => import('./homepage/BlogsDetail'));
const BlogsDynamic = lazy(() => import('./homepage/BlogsDynamic'));

const root = ReactDOM.createRoot(document.getElementById('root'));

const url = BlogListDetails?.BlogList?.map((element) => element?.link)

const changeRoute = (() => {
  if (url.find((m) => ("/" + m) === window.location.pathname)) {
    window.location.href = `/blogs${window.location.pathname}`
  }
})

changeRoute();

root.render(
  <BrowserRouter>
    <Suspense fallback={null}>
    <Routes>
      <Route path='/' element={<Mainpage />} />
      <Route path='*' element={<PageNotFound />} />
      <Route path='/commingsoon' element={<Commingsoon />} />
      <Route path='/arihant-enclave' element={<App />} />
      <Route path='/aspire-silicon-city' element={<AspireSiliconCity />} />
      <Route path='/aspire-leisure-valley' element={<AuAspireSiliconCity />} />
      <Route path='/cosmos-corner' element={<CosmosCorner />} />
      <Route path='/bbf-scholar-program' element={<BbfScholarProgram />} />
      <Route path='/application-form' element={<BbfApplicationForm />} />
      <Route path='/thank-you' element={<Thankyou />} />
      <Route path='/family-hub' element={<Familyhub />} />
      <Route path='/thank-you-aspire-leisure-valley' element={<ThankyouLeisureValley/>} />
      <Route path='/thank-you-family-hub' element={<ThankyouFamilyHub />} />
      <Route path='/aboutus' element={<Aboutus />} />
      <Route path='/news' element={<Newspage />} />
      <Route path='contactus' element={<Contactus />} />
      <Route path='contactus' element={<Contactus />} />
      <Route path='commingsoonpage' element={<Commingsoonpage />} />
      <Route path='privacy-policy' element={<Privacypolicy />} />
      <Route path='disclaimer' element={<Disclaimer />} />
      <Route path='terms' element={<Terms />} />
      <Route path='advisorycomingsoon' element={<Advisorycomingsoon />} />
      <Route path='servicecomingsoon' element={<Servicecomingsoon />} />
      <Route path='jointcomingsoon' element={<Jointcomingsoon />} />
      <Route path='career' element={<Career />} />
      <Route path='service' element={<Service />} />
      <Route path='advisory' element={<Advisory />} />
      <Route path='joint-ventures' element={<Jointventures />} />
      <Route path='thankyou' element={<Thankyoumain />} />
      {/* <Route path='residences' element={<Residences />} /> */}
      {/* <Route path='commercial' element={<Commercial />} /> */}
      <Route path='blogs' element={<BlogsDynamic />} />
      <Route path='blogs/examining-indias-latest-real-estate-budget' element={<Blogdetail />} />
      <Route path='blogs/exploring-2024-trends-in-real-estate-market-in-india' element={<Blogdetail2 />} />
      <Route path='blogs/key-considerations-for-purchasing-residential-plots-in-ghaziabad' element={<Blogdetail3 />} />
      <Route path='blogs/exploring-essential-drivers-in-real-estate-growth-and-investment' element={<Blogdetail5 />} />
      <Route path='blogs/what-makes-investing-in-residential-property-in-ghaziabad-a-smart-choice' element={<Blogdetail6 />} />
      <Route path='blogs/wealth-building-101-a-guide-to-choosing-the-right-property-investment-company' element={<Blogdetail7 />} />
      <Route path='blogs/community-connectivity-the-impact-of-location-on-commercial-spaces' element={<Blogdetail8 />} />
      <Route path='blogs/how-do-ghaziabads-residential-plots-offer-a-canvas-for-personalized-dream-homes' element={<Blogdetail9 />} />
      <Route path='blogs/beyond-the-ordinary-6-features-that-define-a-lavish-home' element={<Blogdetail10 />} />
      <Route path='blogs/how-to-choose-the-right-real-estate-project-in-ghaziabad' element={<Blogdetail11 />} />
      <Route path='blogs/what-to-expect-from-a-leading-property-investment-company' element={<Blogdetail12 />} />
      <Route path='blogs/how-a-consultant-turbocharges-your-home-buying-in-2024' element={<Blogdetail13 />} />
      <Route path='blogs/7-advantages-of-real-estate-joint-ventures-in-india' element={<Blogdetail14 />} />
      <Route path='blogs/investing-in-luxury-aditya-world-city-nh-24s-top-projects' element={<Blogdetail15 />} />
      <Route path='blogs/beyond-investment-the-cultural-and-social-impact-of-real-estate-projects-in-india' element={<Blogdetail16 />} />
      <Route path='blogs/are-government-initiatives-influencing-real-estate-investment-choices-in-india' element={<Blogdetail17 />} />
      <Route path='blogs/plotting-the-dream-design-inspiration-for-residential-plots-in-ghaziabad' element={<Blogdetail18 />} />
      <Route path='blogs/what-are-the-benefits-of-working-with-a-top-rated-property-investment-firm' element={<Blogdetail19 />} />
      <Route path='blogs/discovering-the-best-deals-on-commercial-shops-for-sale-9-important-tips' element={<Blogdetail20 />} />
      <Route path='blogs/what-impact-does-the-right-living-space-have-on-family-well-being' element={<Blogdetail21 />} />
      <Route path='blogs/why-ghaziabad-is-perfect-for-commercial-real-estate-investment' element={<Blogdetail22 />} />
      <Route path='blogs/embracing-natures-haven-exploring-local-parks-for-serenity-and-recreation' element={<Blogdetail23 />} />
      <Route path='blogs/gated-community-living-security-amenities-and-community-spirit' element={<Blogdetail24 />} />
      <Route path='blogs/home-is-where-the-heart-is-a-love-letter-to-simple-joys' element={<Blogdetail25 />} />
      <Route path='blogs/the-rise-of-smart-homes-integrating-technology-in-residential-plots-in-ghaziabad' element={<Blogdetail26 />} />
      <Route path='blogs/how-do-premium-houses-redefine-modern-living-standards' element={<Blogdetail27 />} />
      <Route path='blogs/6-qualities-that-distinguishes-best-real-estate-companies-in-india' element={<Blogdetail28 />} />
      <Route path='blogs/why-use-a-real-estate-advisor-whats-in-it-for-you' element={<Blogdetail29 />} />
      <Route path='blogs/the-psychology-of-space-how-your-residential-plot-impacts-mental-well-being' element={<Blogdetail30 />} />
      <Route path='blogs/the-soul-of-the-space-adding-personality-to-residential-plot-interiors' element={<Blogdetail31 />} />
      <Route path='blogs/top-7-reasons-to-consider-investing-in-commercial-property' element={<Blogdetail32 />} />
      <Route path='blogs/top-secrets-to-finding-the-perfect-commercial-property-for-sale' element={<Blogdetail33 />} />
      <Route path='blogs/how-to-find-your-dream-luxury-house-in-india' element={<Blogdetail34 />} />
      <Route path='blogs/how-to-spot-the-best-upcoming-real-estate-projects-near-you' element={<Blogdetail35 />} />
      <Route path='blogs/how-to-choose-the-best-real-estate-company-for-your-needs' element={<Blogdetail36 />} />
      <Route path='blogs/indian-rupee7979-per-sq-ft-–-the-new-luxury-benchmark-in-greater-noida-west' element={<Blogdetail37 />} />
      <Route path='blogs/:slug' element={<BlogsDetail />} />
    </Routes>
    </Suspense>
  </BrowserRouter>
);